<span [class]="computedClass" [ngStyle]="style">
  @if (icon) {
    <span class="p-tag-icon" [ngClass]="icon" aria-hidden="true"></span>
  }

  <span class="p-tag-value">
    @if (!hasProjectedContent) {
      {{ value }}
    } @else {
      <ng-content></ng-content>
    }
  </span>
</span>

